import React from 'react';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
type PageShellProps = {
  children: React.ReactNode;
};

/**
 * Shared page frame: fixed navigation, the page's main content, and the footer.
 * Adding a route is now a matter of composing sections inside this.
 */
export function PageShell({
  children
}: PageShellProps) {
  return <div className="min-h-screen w-full overflow-x-hidden bg-paper text-ink" data-id="element-597" data-mp="38fod9ft9i9eg">
      <Navbar data-id="element-598" data-mp="2ihsxenohan" />
      <main data-id="element-599" data-mp="2qy6z9zm4ql">{children}</main>
      <Footer data-id="element-600" data-mp="51281a0a8f8t" />
    </div>;
}